export const GoogleMapApiConfig = 'AIzaSyAiXJwbMMYEIRNcyvpEyaaIzFDgL75jTR8';